import { WSCRow } from "./WSCRow";
/** Player portraits already include the designed number, glow and name. */
export class PlayersRow extends WSCRow {
    createCard(item) {
        return Object.assign(Object.assign({}, super.createCard(item)), { Glow: { visible: false }, Labels: { visible: false } });
    }
}
export default PlayersRow;
//# sourceMappingURL=PlayersRow.js.map